import React from 'react'
import { Helmet } from 'react-helmet'

import { generateStructuredData, getPageSEOConfig } from '../../utils/seoUtils'

const SEOHead = ({ title, description, keywords, image, url, type = 'website', locale = 'en', alternateLocales = ['zh'], pageName, structuredDataType }) => {
  const siteTitle = 'BookingOnSnow'

  // Use page-specific config if pageName is provided
  const pageConfig = pageName ? getPageSEOConfig(pageName) : null
  const finalTitle = title || pageConfig?.title || siteTitle
  const fullTitle = finalTitle === siteTitle ? siteTitle : `${finalTitle} | ${siteTitle}`

  const defaultDescription = 'Book professional ski and snowboard lessons with certified instructors. Private lessons, group sessions, and ski trips in Ottawa and Eastern Canada.'
  const finalDescription = description || pageConfig?.description || defaultDescription

  const defaultKeywords =
    '滑雪教学, 单板滑雪课程, 滑雪教练, 渥太华滑雪教学, 滑雪初学者课程, 户外运动, 冬天户外运动, 冬季运动培训, 滑雪度假村旅行, 儿童滑雪课程, 团体滑雪课程, ski lessons, snowboard lessons, ski instructor, Ottawa ski lessons, winter sports'
  const finalKeywords = keywords || pageConfig?.keywords || defaultKeywords

  const defaultImage = '/logo512.png'
  const siteUrl = 'https://bookingonsnow.com'
  const finalUrl = url || siteUrl

  // Generate structured data if type is specified
  const structuredData = structuredDataType ? generateStructuredData(structuredDataType) : null

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:locale" content={locale} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={finalUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={finalDescription} />
      <meta property="twitter:image" content={image || defaultImage} />

      {/* Language and Region */}
      <meta name="language" content={locale} />
      <meta name="geo.region" content="CA-ON" />
      <meta name="geo.placename" content="Ottawa" />
      <meta name="geo.position" content="45.4215;-75.6972" />
      <meta name="ICBM" content="45.4215, -75.6972" />

      {/* Alternative Language Links */}
      {alternateLocales.map((lang) => (
        <link key={lang} rel="alternate" hreflang={lang} href={finalUrl} />
      ))}
      <link rel="alternate" hreflang="x-default" href={finalUrl} />

      {/* Canonical URL */}
      <link rel="canonical" href={finalUrl} />

      {/* Structured Data */}
      {structuredData && <script type="application/ld+json">{JSON.stringify(structuredData)}</script>}
    </Helmet>
  )
}

export default SEOHead
